<template>
	<div class="home-container">
		<van-nav-bar class="nav-bar">
			<template #title>
				<van-image round height="40" width="110" style="margin: 10px 0px 0px;"
					src="img/home/homenavlogo.png" />
			</template>
		</van-nav-bar>
		<div class="linear-bg"></div>
		<div class="home-scroll">
			<!-- banner广告 -->
			<div class="banner">
				<swiper class="banner_swiper" :options="bannerSwiperOption">
					<swiper-slide v-for="(v,key) in banners" :key="key">
						<van-image class="banner_img" round :src="v.url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
					</swiper-slide>
				</swiper>
			</div>
			<!-- 公告区 -->
			<div class="notice-bar">
				<van-notice-bar class="notice-swipe" left-icon="bullhorn-o" background="#ffffff" color="#7e5678"
					:text="this.notice" />
				<div class="linear-gradient"></div>
			</div>

			<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="loading..." loading-text="loading...">
				<div class="hot-recommend">
					<div class="hot-title-div">
						<div>
							<span>{{$t("尽享高端区")}}</span>
							<i> {{$t("享受极致奢华体验")}} </i>
						</div>

					</div>
					<div style="display: flex; width: 100%; overflow-y: auto; flex-wrap: nowrap;">
						<div class="gdgride" v-for="(item,key) in xuanfei_list" :key="key">
							<div>
								<van-image round width="100" height="100" radius="8"
									:src="item.img_url" />
								<span><i>{{$t("空降")}}</i></span>
								<div class="gdgride_title"> {{item.xuanfei_name}} </div>
							</div>
							
						</div>
						<!-- <div class="gdgride">
							<div>
								<van-image round width="100" height="100" radius="8"
									src="http://sweet.pornhub0006.com/xuanfei/20240710\348ebf29bbaceb9f2dedae12d39d616b.jpg" />
								<span><i>空降</i></span>
								<div class="gdgride_title"> 는 </div>
							</div>
							<div>
								<van-image round width="100" height="100" radius="8"
									src="http://sweet.pornhub0006.com/xuanfei/20240710\348ebf29bbaceb9f2dedae12d39d616b.jpg" />
								<span><i>空降</i></span>
								<div class="gdgride_title"> 는 </div>
							</div>
						</div> -->
						<div class="gdgride_more"> {{$t("查看更多")}} </div>
					</div>
					<div class="hot-title-div">
						<div>
							<span>{{$t("热门推荐")}} </span>
						</div>

					</div>
					<div class="movie-list-item">
						<div class="horizontalItem"  v-for="(item,key) in xuanfei_list" :key="key">
							<div class="imgBox">
								<van-image round width="120" height="120" radius="8" fit="cover" :src="item.img_url" />
								<span><i>{{$t("高端")}} </i></span>
							</div>
							<div style="width: calc(100% - 140px);">
								<div class="top">
									<div>
										<van-image width="13" src="img/home/vip.png" />
										<span>{{$t("认证")}} </span>
									</div>
									<div>
										<van-image width="13" src="img/home/vip.png" />
										<span>{{$t("视频认证")}} </span>
									</div>
									<div>{{item.xuanfei_name}}</div>
								</div>
								<div class="tags">
									<van-tag type="default">{{item.tag1}}</van-tag>
									<van-tag type="success">{{item.tag2}}</van-tag>
									<van-tag type="danger">{{item.tag3}}</van-tag>
									<van-tag type="warning">{{item.tag4}}</van-tag>
								</div>
								<div style="display: flex; align-items: center;">
									<span style="font-size: 14px; color: rgb(102, 102, 102);">{{$t("收费区间")}}：</span>
									<div tabindex="0" role="radiogroup" class="van-rate">
										<div role="radio" tabindex="0" aria-setsize="5" aria-posinset="1"
											class="van-rate__item" aria-checked="true">
											<van-icon name="star" color="#ffd21e" size="18" />
										</div>
										<div role="radio" tabindex="0" aria-setsize="5" aria-posinset="1"
											class="van-rate__item" aria-checked="true">
											<van-icon name="star" color="#ffd21e" size="18" />
										</div>
										<div role="radio" tabindex="0" aria-setsize="5" aria-posinset="1"
											class="van-rate__item" aria-checked="true">
											<van-icon name="star" color="#ffd21e" size="18" />
										</div>
										<div role="radio" tabindex="0" aria-setsize="5" aria-posinset="1"
											class="van-rate__item" aria-checked="true">
											<van-icon name="star" color="#ffd21e" size="18" />
										</div>
										<div role="radio" tabindex="0" aria-setsize="5" aria-posinset="1"
											class="van-rate__item" aria-checked="true">
											<van-icon name="star" color="#ffd21e" size="18" />
										</div>
									</div>
								</div>
								<div style="color: rgb(153, 153, 153); font-size: 12px; margin: 5px 0px;"> {{$t("身高")}}: {{item.height}}
									{{$t("胸围")}}:{{item.xiongwei}}
									{{$t("服务城市：全国各地 航空运输：是")}}</div>
								<div class="yueta" @click = "addgo(item)">{{$t("我要约她")}} </div>
							</div>
						</div>
						
					</div>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				notice: this.$t("获取中") + "......",
				banners: [{}],
				basicData: [],
				movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
				isLoading: false,
				xuanfei_list:[],
				bannerSwiperOption: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					speed: 800,
					autoplay: true,
					coverflowEffect: {
						rotate: 50,
						stretch: 10,
						depth: 100,
						modifier: 1,
						slideShadows: true
					}
				}
			};
		},
		methods: {
			gotoMenu(router) {
				this.$router.replace(router)
			},
			addgo(data) {
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					});
				} else {
					this.$router.push({
						path: '/profile?id=' + data.id
					});
				}
			},

			onRefresh() {
				setTimeout(() => {
					this.getBasicConfig();
					this.isLoading = false;
					this.$toast(this.$t("刷新成功") );
				}, 500);
			},
			getBasicConfig() {
				this.$http({
					method: 'get',
					url: 'sys_config'
				}).then(res => {
					this.basicData = res.data;
					this.getNotice(this.basicData); //获取公告
					this.getBanner(this.basicData); //获取banner
				})

			},
			getNotice(data) {
				this.notice = data.notice;
			},

			getxuanfeilist() {
				this.$http({
					method: 'get',
					url: 'xuanfeilist',
				}).then(res => {
					this.xuanfei_list = res.data;
				});
			},
			
			getBanner(data) {
				this.banners = data.banners;
			}
		},
		mounted() {

		},
		created() {
			this.getBasicConfig();
			this.getxuanfeilist();
		}
	}
</script>

<style lang='less' scoped>
	@notice-bar-size: 30px;
	@movie-list-item-bottom-size: 25px;

	.horizontalItem {
		display: flex;
		border-bottom: 1px solid #eee;
		padding: 2.667vw 0 4vw;
	}

	.horizontalItem .imgBox {
		position: relative;
		overflow: hidden;
		border-radius: 1.067vw;
		margin-right: 2.667vw;
	}

	.horizontalItem .imgBox>span {
		position: absolute;
		z-index: 9;
		background-color: #ebcaaf;
		color: #8d684b;
		transform: rotate(45deg);
		width: 20vw;
		height: 20vw;
		top: -11vw;
		right: -11vw;
	}

	.horizontalItem .imgBox>span>i {
		position: absolute;
		bottom: .667vw;
		left: 50%;
		transform: translateX(-50%);
		font-weight: 700;
		font-size: 4vw;
	}

	.horizontalItem .top {
		display: flex;
	}

	.horizontalItem .top>div:first-child,
	.horizontalItem .top>div:nth-child(2) {
		background: linear-gradient(180deg, #e7caaf, #fff7ed);
		color: #a4826b;
		font-weight: 600;
		font-size: 3vw;
		padding: .4vw;
		margin-right: 1.333vw;
	}

	.horizontalItem .tags {
		display: flex;
		margin: .667vw 0 .667vw;
		flex-wrap: wrap;
	}

	.horizontalItem .tags>.van-tag {
		padding: .667vw;
		font-size: 3.333vw;
		margin: 0 .667vw .667vw 0;
		border-radius: 1.067vw;
		line-height: 4vw;
	}

	.horizontalItem .yueta {
		background: linear-gradient(90deg, #df35ad, #4f1db5);
		color: #fff;
		border-radius: 1.067vw;
		padding: 1.333vw 0;
		text-align: center;
		font-size: 4vw;
	}

	.gdgride {
		padding-right: 5.333vw;
		margin-right: 5px;
	}

	.gdgride>div {
		position: relative;
		overflow: hidden;
		border-radius: 1.067vw;
	}

	.gdgride>div>span {
		position: absolute;
		z-index: 9;
		background-color: #ebcaaf;
		color: #8d684b;
		transform: rotate(45deg);
		width: 20vw;
		height: 20vw;
		font-size: 3vw;
		top: -11vw;
		right: -11vw;
	}

	.gdgride>div>span>i {
		position: absolute;
		bottom: .667vw;
		left: 50%;
		transform: translateX(-50%);
		font-weight: 700;
	}

	.gdgride_title {
		position: absolute;
		bottom: 10px;
		text-align: center;
		color: rgb(255, 255, 255);
		width: 100%;
		font-size: 12px;
	}

	.gdgride_more {
		width: 23px;
		padding: 20px 5px 10px;
		height: 145px;
		margin-top: 30px;
		background: rgb(249, 249, 249);
		color: rgb(153, 153, 153);
		font-size: 12px;
	}

	.linear-bg {
		height: 200px;
		background: linear-gradient(270deg, #e6c3a1, #7e5678);
	}

	.home-container {
		position: absolute !important;
		top: 0;
		left: 0;
		right: 0;
		background-color: #ffffff;
	}

	.linear-gradient {
		width: 100%;
		height: 2px;
		background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));
	}

	::v-deep .van-notice-bar__left-icon,
	.van-notice-bar__right-icon {
		min-width: 40px;
	}

	.notice-swipe {
		width: calc(100% - 50px);
		height: 85px;
		font-size: @notice-bar-size;
	}

	::v-deep .van-icon-bullhorn-o::before {
		transform: scale(2.5);
	}

	.banner {
		width: 100%;
		margin-top: -23%;
	}

	.banner_swiper {
		height: 100%;
		width: 100%;

		.swiper-slide {
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 620px;
			height: 300px;
			text-align: center;
			font-weight: bold;
			font-size: 20px;
			background-color: #ffffff;
			background-position: center;
			background-size: cover;
			color: #ffffff;
		}
	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-left {
		background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-right {
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	.banner_img {
		border-radius: 10px;
		width: 100%;
		height: 100%;
	}

	.hot-game {
		width: 100%;
		height: 100%;
	}

	.hot-title-div {
		margin: 0 auto;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.hot-title-div div {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.hot-title-div>div:nth-child(2) span {
		font-size: 20px;
		color: #979799;
	}

	.hot-title-div>div:first-child span {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 3.733vw;
		color: #000;
	}

	.hot-title-div>div:nth-child(2) span {
		font-size: 25px;
		color: #979799;
	}

	.hot-title-div>div:first-child span:before {
		content: "";
		display: block;
		width: 5px;
		height: 30px;
		background-color: #7e5678;
		border-radius: 1px;
		margin-right: 5px;
	}

	.hot-title-div>div:first-child i {
		background: #3f3a5b;
		padding: .533vw;
		color: #ebcaaf;
		font-size: 2.933vw;
		border-radius: 1.067vw 0;
	}

	.hot-game .hot-items-div {
		margin-top: -3px;
	}

	.hot-game .hot-items-div span {
		margin-top: 10px;
		font-size: 28px;
		color: #000;
	}

	.hot-recommend {
		padding: 2.667vw;
		width: 100%;
		flex: 1;
		background-color: #f2f2f5;
	}

	.movie_swiper {
		.swiper-slide {
			width: 80%;
		}
	}

	.movie_list_0 {
		width: calc(100% - 50px);
		margin: 0 auto;
	}

	.movie_cover {
		border-radius: 10px;
		width: 550px;
		height: 330px
	}

	.movie_list_0 .movie-list-item-bottom {
		position: relative;
		width: 550px;
		bottom: 43px;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_0 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
		font-size: 28px;
		color: #fff;
	}

	.movie_list_0 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
	}

	.movie_list_0 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 80px;
	}

	.movie_list_0 span {
		font-size: 30px;
	}

	.movie_list_1 {
		display: flex;
		width: calc(100% - 50px);
		margin: 0 auto;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.movie_list_1 .movie-list-item .cover_img {
		border-radius: 10px;
		width: 335px;
		height: 290px;
	}

	.home-scroll {
		padding-bottom: 110px;
	}

	.movie_list_1 .movie-list-item {
		margin-bottom: -10px;
	}

	.movie_list_1 .movie-list-item-bottom {
		position: relative;
		width: 335px;
		bottom: 42px;

	}

	.movie_list_1 .movie-list-item:nth-child(odd) {
		margin-right: 25px;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_1 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
		color: #fff;
	}

	.movie_list_1 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
		height: 35px;
	}

	.movie_list_1 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 5px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 180px;
		padding-left: 8px;
		font-size: 25px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:last-child {
		overflow: hidden;
		white-space: nowrap;
		width: 0px;
		padding-right: 110px;
		font-size: 22px;
	}

	.movie_list_0 .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 350px;
		padding-left: 10px;
		font-size: 25px;
	}

	.hot-recommend-more {
		width: 100%;
		padding-bottom: 20px;
		text-align: center;
		color: #979799;
		font-size: 30px;
	}

	.hot-items-div .game_item_img {
		width: 100px;
		height: 100px;
	}

	::v-deep .hot-items-div .game_item_img .van-image__img {
		border-radius: 20px;
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}
</style>